import React, {createContext} from "react";

export const OrderListContext = createContext({
    search: '',
    setSearch: () => {},
    filterMenuSelected: 'LineItemStatus',
    setFilterMenuSelected: () => {},
    filters: {},
    setFilters: () => {},
    organizationCouponCodes: [],
    setOrganizationCouponCodes: () => {},
    selectedFilters: [],
    setSelectedFilters: () => {},
    queryParams: '',
    setQueryParams: () => {},
    isMobile: false
})
